import type { PhishingTask } from "../types";

export function senderDomain(address: string): string {
  const at = address.lastIndexOf("@");
  return at === -1 ? "" : address.slice(at + 1).toLowerCase();
}

function linkHost(href: string): string {
  const withoutScheme = href.replace(/^[a-z]+:\/\//i, "");
  return (withoutScheme.split(/[/?#]/)[0] ?? "").toLowerCase();
}

function isTrusted(host: string, trustedDomains: readonly string[]): boolean {
  return trustedDomains.some((domain) => host === domain || host.endsWith(`.${domain}`));
}

/** sender_check: emails whose sender domain is not one of the client's trusted domains. */
export function externalSenderIndices(task: PhishingTask): number[] {
  return task.emails
    .map((email, index) => (isTrusted(senderDomain(email.from.address), task.trustedDomains) ? -1 : index))
    .filter((index) => index >= 0);
}

/** link_preview: emails with a link whose host is outside the trusted domains. */
export function linkMismatchIndices(task: PhishingTask): number[] {
  return task.emails
    .map((email, index) =>
      email.link && !isTrusted(linkHost(email.link.href), task.trustedDomains) ? index : -1,
    )
    .filter((index) => index >= 0);
}

/** Phishing skill Lv1: how many emails in the inbox are phishing. */
export function phishingCount(task: PhishingTask): number {
  return task.emails.filter((email) => email.isPhishing).length;
}
